import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles" {
  interface Palette {
    appContainerBackground: string
  }

  interface PaletteOptions {
    appContainerBackground: string
  }
}

const wellPayTheme = createMuiTheme({
  typography: {
    fontFamily: [
      "Montserrat",
      "Poppins",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#10546C", // Midnight Green
      dark: "#151435", // Space Cadet Blue
    },
    secondary: {
      main: "#333333", // Jet Gray
      dark: "#151435", // fallback dark
      light: "#10546C", // fallback light
    },
    error: {
      main: "#b11f24",
    },
    background: {
      default: "#fff",
      paper: "#f7f9fd",
    },
    text: {
      primary: "#333333", // Jet Gray
      secondary: "#10546C", // Midnight Green for accents
    },
    info: {
      main: "#151435",
    },
  },
  // appContainerBackground: "linear-gradient(to right, #10546C, #151435)", // custom gradient
  overrides: {
    MuiButton: {
      contained: {
        borderRadius: "6px",
        padding: "12px 24px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "14px",
        width: "200px",
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      },
      text: {
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  },
})

export default wellPayTheme
